// reducers.ts
import { combineReducers } from "@reduxjs/toolkit";
import configStateSlice from "./client.configSlice";
import addressSlice from "./address.slice";
import countrystateSlice from "./country.slice";
import userStateSlice from "./user.slice";
import  s3UploadSlice  from "./s3upload.slice";
import  authStateSlice  from "./auth.slice";
import deviceConfigStateSlice from "./deviceConfig.slice";

// Define reducers
const rootSlice = combineReducers({
  configStateReducer: configStateSlice,
  addressStateReducer: addressSlice,
  countryStateReducer: countrystateSlice,
  userStateReducer: userStateSlice,
  s3UploadReducer: s3UploadSlice,
  authStateReducer: authStateSlice,
  deviceConfigReducer : deviceConfigStateSlice
});

export type RootStateType = ReturnType<typeof rootSlice>;
export default rootSlice;
